module.exports = __webpack_public_path__ + "img/2000.71a95ab2.png";